/* eslint-disable react/react-in-jsx-scope */
import DelhiSelected from '../icons/cities/DelhiSelected.svg';
import DelhiUnselected from '../icons/cities/DelhiUnselected.svg';
import DelhiMobile from '../icons/cities/DelhiMobile.svg';

import AmritsarSelected from '../icons/cities/AmritsarSelected.svg';
import AmritsarUnselected from '../icons/cities/AmritsarUnselected.svg';
import AmritsarMobile from '../icons/cities/AmritsarMobile.svg';

import MumbaiSelected from '../icons/cities/MumbaiSelected.svg';
import MumbaiUnSelected from '../icons/cities/MumbaiUnselected.svg';
import MumbaiMobile from '../icons/cities/MumbaiMobile.svg';

import AhmedabadSelected from '../icons/cities/AhmedabadSelected.svg';
import AhmedabadUnselected from '../icons/cities/AhmedabadUnselected.svg';
import AhmedabadMobile from '../icons/cities/AhemedabadMobile.svg';

import HyderabadSelected from '../icons/cities/HyderabadSelected.svg';
import HyderabadUnselected from '../icons/cities/HyderabadUnselected.svg';
import HyderabadMobile from '../icons/cities/HyderabadMobile.svg';

import AgraSelected from '../icons/cities/AgraSelected.svg';
import AgraUnselected from '../icons/cities/AgraUnselected.svg';
import AgraMobile from '../icons/cities/AgraMobile.svg';

export const CITY_LIST = [
  {
    name: 'New Delhi',
    selectedIcon: <DelhiSelected />,
    unSelectedIcon: <DelhiUnselected />,
    mobileIcon: <DelhiMobile />,
    id: 4
  },
  {
    name: 'Amritsar',
    selectedIcon: <AmritsarSelected />,
    unSelectedIcon: <AmritsarUnselected />,
    mobileIcon: <AmritsarMobile />,
    id: 66
  },
  {
    name: 'Mumbai',
    selectedIcon: <MumbaiSelected />,
    unSelectedIcon: <MumbaiUnSelected />,
    mobileIcon: <MumbaiMobile />,
    id: 3
  },
  {
    name: 'Ahmedabad',
    selectedIcon: <AhmedabadSelected />,
    unSelectedIcon: <AhmedabadUnselected />,
    mobileIcon: <AhmedabadMobile />,
    id: 6
  },
  {
    name: 'Hyderabad',
    selectedIcon: <HyderabadSelected />,
    unSelectedIcon: <HyderabadUnselected />,
    mobileIcon: <HyderabadMobile />,
    id: 10
  },
  {
    name: 'Agra',
    selectedIcon: <AgraSelected />,
    unSelectedIcon: <AgraUnselected />,
    mobileIcon: <AgraMobile />,
    id: 25
  },
];

export const USER_CITY = 'user_selected_city';
